module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114137_94_157.1156fa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114137_94_157.jpg
// module id = RB1z
// module chunks = 0